import { defineStore } from 'pinia';
import { KohtumineTegevusTeavitus } from '@/models/KohtumineTegevus';

export type TegevusedState = {
  tegevused: Array<KohtumineTegevusTeavitus>;
  tegevusedSaadud: boolean;
};

export const useTegevusedStore = defineStore('tegevusedStore', {
  state: () => {
    return {
      tegevused: new Array<KohtumineTegevusTeavitus>(),
      tegevusedSaadud: false,
    } as TegevusedState;
  },
  persist: { storage: sessionStorage },
  actions: {
    satiTegevused(dto: Array<KohtumineTegevusTeavitus>) {
      this.tegevused = { ...dto };
      this.tegevusedSaadud = true;
    },
    eemaldaTegevused() {
      this.tegevused = new Array<KohtumineTegevusTeavitus>();
      this.tegevusedSaadud = false;
    }
  },
});
